import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/layouts/default.vue").then(m => m.default || m))
}